import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

interface TabListType {
    name: string;
    /** 用于绑定吸顶 ID */
    moduleId: RuleTabModuleIdEnum;
}

export enum RuleTabModuleIdEnum {
    Overview = 'rule-overview',
    DataCenters = 'rule-data-centers',
    ComplianceQualifications = 'rule-compliance-qualifications',
    FrequentlyAskedQuestions = 'rule-frequently-asked-questions',
}

export default function PageComp() {
    const { t } = useLang('rule');

    //  控制吸顶
    const tabRef = useRef<HTMLDivElement>(null);
    const HEADER_CLASS_NAME = '.ecoflow-frame-header';
    useEffect(() => {
        const header = document.querySelector(HEADER_CLASS_NAME) as HTMLElement;
        if (header) {
            const resize = new ResizeObserver((entries) => {
                entries.forEach((entry) => {
                    const { height } = entry.contentRect;
                    tabRef.current && (tabRef.current.style.top = `${height}px`);
                });
            });
            resize.observe(header);
            return () => resize.disconnect();
        }
    }, []);

    const [tabList] = useState<TabListType[]>([
        {
            name: t('Tab_title1'),
            moduleId: RuleTabModuleIdEnum.Overview,
        },
        {
            name: t('Tab_title2'),
            moduleId: RuleTabModuleIdEnum.DataCenters,
        },
        {
            name: t('Tab_title3'),
            moduleId: RuleTabModuleIdEnum.ComplianceQualifications,
        },
        {
            name: t('Tab_title4'),
            moduleId: RuleTabModuleIdEnum.FrequentlyAskedQuestions,
        },
    ]);
    const [currentTab, setCurrentTab] = useState(tabList[0].moduleId);
    // tab 切换动画
    const tabsRef = useRef<HTMLDivElement>(null);
    const stopScroll = useRef(false);
    const timer = useRef<NodeJS.Timeout | null>(null);
    const handlerChangeTab = (item: TabListType, viewport = true) => {
        const tabModule = document.querySelector(`#${item.moduleId}`) as HTMLElement;
        const tabItem = document.querySelector(`.tab-item-${item.moduleId}`) as HTMLElement;
        if (tabModule && viewport) {
            stopScroll.current = true;
            timer.current && clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                stopScroll.current = false;
            }, 1000);
            window.scrollTo({ top: tabModule.offsetTop, behavior: 'smooth' });
        }
        if (tabsRef.current && tabItem) {
            const centerNum = tabItem.offsetLeft - tabsRef.current.offsetWidth / 2 + tabItem.offsetWidth / 2;
            tabsRef.current.scrollTo({ left: centerNum, behavior: 'smooth' });
        }

        setCurrentTab(item.moduleId);
    };
    useEffect(() => {
        const offset = 300; // 顶部偏移量
        const ids = Object.values(RuleTabModuleIdEnum).filter((i) => tabList.findIndex((item) => item.moduleId === i) > -1);
        const tops = ids.map((i) => {
            const moduleEl = document.querySelector(`#${i}`) as HTMLElement;
            return moduleEl.offsetTop - offset;
        });
        const handlerScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const index = tops.findIndex((i, idx) => scrollTop >= i && scrollTop < (tops[idx + 1] ?? scrollHeight));
            if (index !== -1 && !stopScroll.current) {
                handlerChangeTab(tabList[index], false);
            }
        };
        window.addEventListener('scroll', handlerScroll);
        return () => window.removeEventListener('scroll', handlerScroll);
    }, [tabList]);

    return (
        <div className={`${css['page-comp']}`} ref={tabRef}>
            <div className="tabs" ref={tabsRef}>
                {tabList.map((item) => (
                    <div
                        className={`tab-item tab-item-${item.moduleId} ${currentTab === item.moduleId ? 'active' : ''} `}
                        onClick={() => handlerChangeTab(item)}
                        key={item.moduleId}
                    >
                        {item.name}
                    </div>
                ))}
            </div>
        </div>
    );
}
